<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.PCHECK' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>

		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
		</app-included-per-passenger>

		<div class="sidebar-flight-text top-gap">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsPriorityCheckin.titles.priorityCheckin' | ibeadmin: 'sync' }}
			</h2>
			<p>
				{{ 'whatsIncludedSidebars.detailsPriorityCheckin.texts.info1' | ibeadmin: 'sync' }}
			</p>
			<p>
				{{ 'whatsIncludedSidebars.detailsPriorityCheckin.texts.info2' | ibeadmin: 'sync' }}
			</p>
			
		</div>
		<div class="sidebar-flight-text">
			<p>
				{{ 'whatsIncludedSidebars.detailsPriorityCheckin.texts.milesAndGoInfo' | ibeadmin: 'sync' }}
			</p>
			<a (click)="INDRA_gotoURL()"  
				class="link extras-feature__link link--external" 
				aria-label="Open All about priority check-in, opens new window">
				{{'whatsIncludedSidebars.detailsPriorityCheckin.texts.allAboutPriorityCheckin' | ibeadmin: 'sync'}}
			</a>
		</div>

		<app-compare-brands [feature]="feature" [brand]="brand" *ngIf="!reviewFlights && !timeToThinkFlights"></app-compare-brands>
		<div class="extras__helper with-notification">
			<div class="">
				<a class="link extras-feature__link" 
					aria-label="Close dialog"
					(click)="INDRA_handleClose()" 
					href="javascript:;" 
					role="button">
					{{'whatsIncludedSidebars.detailsPriorityCheckin.texts.closeWindow' | ibeadmin: 'sync'}}
				</a>
			</div>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>


